import React from 'react';
import PropTypes from 'prop-types';
import CustomSelect from 'components/CustomSelect';
import { typeAccount, tooltipAccountBank } from 'config';
import Rut from 'components/Forms/Inputs/InputRut';
import Tooltip from 'components/Tooltip';
import Checkbox from 'components/Forms/Inputs/ChecksGroup/checkbox';
import style from './style.scss'

const BankAccountForm = (props) => {
    const {
        listBank,
        _typeBank,
        typeBankSelected,
        _typeAccount,
        typeAccountSelected,
        bankAccountError,
        rutValid,
        email,
        rutData,
        onCardChange,
        cardValue,
        checkbox,
        onChangeInput,
        onChangeNameTitular,
        nameTitular
    } = props;

    let bankAccountMessage = 'Debes ingresar un nro. de cuenta válido'
    const cardNumberValue = cardValue ? cardValue : '';

    return (
        <div className="bank-account-data-user">
            <div className="bank-account-user-mail-wrap">
                <Tooltip message={tooltipAccountBank} timer={10000}  type={'tooltip_account_bank_mail'} >
                    {(visible) => {
                        return <div className={"bank-account-user-mail-tooltip" + (visible ? ' visible' : '')}>
                            <div className="bank-account-user-mail-container">
                                <label className="bank-account-user-title disabled">Mail</label>
                                <div className={'bank-account-user-tooltip-container '} >
                                    <i className="jumbo-icon-new-info"></i>
                                </div>
                            </div>
                            
                            <span className="bank-account-user-required">Obligatorio</span>
                        </div> 
                    }}
                </Tooltip>
                
                <input className="bank-account-input input-default" type="email" name="email" value={email} disabled />
            </div>

            <div className="bank-account-user-name-wrap">
                <div className="bank-account-user-title-container">
                    <label className="bank-account-user-title ">Nombre del titular</label>
                    <span className="bank-account-user-required">Obligatorio</span>
                </div>
                <input className="bank-account-input input-default" type="text" name="firstName" defaultValue={nameTitular} onChange={onChangeNameTitular} />
            </div>

            <div className="bank-account-user-rut-wrap">
                <div className="bank-account-user-title-wrap">
                    <label className={'bank-account-user-title '}>RUT</label>
                    <span className="bank-account-user-required">Obligatorio</span>
                </div>
                <Rut 
                    defaultRut={rutData} 
                    callbackisValid={rutValid} 
                    placeholder={'Eje: 11.111.111-1'} 
                    disabled={false}
                    notDisabled={true}
                />
            </div>

            <div className="modal-bank-account-data" id="account-data-bank">
                <div className="bank-account-user-title-wrap">
                    <label className="modal-bank-account-data-title">Banco</label>
                    {!typeBankSelected && <span className="bank-account-user-required">Obligatorio</span>}
                </div>
                <CustomSelect 
                    placeholder={'Seleccione un banco'} 
                    options={listBank} 
                    onChange={_typeBank} 
                    value={typeBankSelected} 
                />
            </div>

            <div className="modal-bank-account-data" id="account-data-account-type">
                <div className="bank-account-user-title-wrap">
                    <label className="modal-bank-account-data-title">Tipo de cuenta</label>
                    {!typeAccountSelected && <span className="bank-account-user-required">Obligatorio</span>}
                </div>
                <CustomSelect
                    placeholder="Selecciona un tipo de cuenta"
                    options={typeAccount}
                    onChange={_typeAccount}
                    value={typeAccountSelected}
                />
            </div>

            <div className={'modal-bank-account-data' + (bankAccountError ? ' is-error' : '')} id="account-data-number-account">
                <div className="bank-account-user-title-wrap number-account">
                    <div className='bank-account-number-cont'>
                        <label className="modal-bank-account-data-title">Número cuenta</label>
                        {!cardNumberValue && <span className="bank-account-user-required">Obligatorio</span>}
                    </div>
                    <span className="bank-account-data-info-text">El número de cuenta aparece en el banco, no en el plástico de la tarjeta.</span>
                    
                </div>
                <input
                    className="modal-bank-account-input input-default"
                    name="accountNumber"
                    type="number"
                    value={cardNumberValue}
                    onChange={onCardChange}
                />
                <p className="error">{bankAccountError ? bankAccountMessage : ''}</p>
            </div>

            <label className="bank-account-user-input-container">
                <Checkbox 
                    type={'checkbox'}
                    name={'Terms Account Bank'}
                    checked={checkbox}
                    onChange={onChangeInput}
                />
                <span className="bank-account-user-terms-span">Autorizo a Cencosud Retail S.A. en caso de existir saldos o reembolso a mi favor, se realicen las devoluciones de pagos de mi tarjeta de débito a esta cuenta Bancaria.</span>
            </label>
        </div>
    )
}

BankAccountForm.propTypes = {
    listBank: PropTypes.array,
    _typeBank: PropTypes.func,
    typeBankSelected: PropTypes.object,
    _typeAccount: PropTypes.func,
    typeAccountSelected: PropTypes.object,
    bankAccountError: PropTypes.bool,
    rutValid: PropTypes.func,
    phoneValid: PropTypes.func,
    phoneValue: PropTypes.string,
    email: PropTypes.string,
    isValid: PropTypes.func,
    rutData: PropTypes.string,
    onCardChange: PropTypes.func,
    cardValue: PropTypes.string,
    phoneData: PropTypes.string
}

export default BankAccountForm;